/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Filters_TitleInputs */

const en_editor_filters_title = /** @type {(inputs: Editor_Filters_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filters`)
};

const fr_editor_filters_title = /** @type {(inputs: Editor_Filters_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtres`)
};

const de_editor_filters_title = /** @type {(inputs: Editor_Filters_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter`)
};

const it_editor_filters_title = /** @type {(inputs: Editor_Filters_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtri`)
};

const ru_editor_filters_title = /** @type {(inputs: Editor_Filters_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фильтры`)
};

const es_editor_filters_title = /** @type {(inputs: Editor_Filters_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtros`)
};

const zh_cn2_editor_filters_title = /** @type {(inputs: Editor_Filters_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`过滤器`)
};

const ja_editor_filters_title = /** @type {(inputs: Editor_Filters_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フィルター`)
};

const hi_editor_filters_title = /** @type {(inputs: Editor_Filters_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फिल्टर`)
};

const pt_pt2_editor_filters_title = /** @type {(inputs: Editor_Filters_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtros`)
};

/**
* | output |
* | --- |
* | "Filters" |
*
* @param {Editor_Filters_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_filters_title = /** @type {((inputs?: Editor_Filters_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Filters_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_filters_title(inputs)
	if (locale === "de") return de_editor_filters_title(inputs)
	if (locale === "it") return it_editor_filters_title(inputs)
	if (locale === "ru") return ru_editor_filters_title(inputs)
	if (locale === "es") return es_editor_filters_title(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_filters_title(inputs)
	if (locale === "ja") return ja_editor_filters_title(inputs)
	if (locale === "hi") return hi_editor_filters_title(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_filters_title(inputs)
	return en_editor_filters_title(inputs)
});